import React from "react";
import styles from "./LandingV3.module.scss";
import bgVideos from "../../assets/images/homepageBG.mp4";
import { bounceIn, Button2 } from "../../components";
import { ARTIST_SEARCH_ESTIMATES, DEAL_COMPARISON, LABELHOME, PARTNERS, PUBLISHING } from "../../routes/constants";
import { motion } from "motion/react"
import { useReducedMotion } from "framer-motion";

function LandingV3 () {
  const reduced = useReducedMotion();
  return (
    <div className={styles.videoHeader}>
      <div className={styles.overlay}></div>
      <video autoPlay={!reduced} loop playsInline muted alt="Video of various musicians playing and performing" className={styles.video}>
        <source src={bgVideos} type="video/mp4" />
      </video>
      <motion.div id="landing" className={styles.landing} {...bounceIn}>
        <div className={styles.titleCtn}>
          <h1 className={styles.title}>
            <span className={styles.primary}>Smarter Choices.</span>
            <span className={styles.secondary}>Better Deals.</span>
          </h1>
          <p className={styles.subtitle}>
            Get offers from multiple partners, compare your choices, and find the deal that's right for you.
          </p>
        </div>
        <div className={styles.landingActions}>
          <p className={styles.actionHeader}>How would you like to get funding?</p>
          <div className={styles.actionButtonCtn}>
            <Button2 light lg to={ARTIST_SEARCH_ESTIMATES} className={styles.actionButton}><p>as an Artist</p> </Button2>
            <Button2 light lg to={LABELHOME} className={styles.actionButton}><p>as a Label</p></Button2>
            <Button2 light lg to={PARTNERS} className={styles.actionButton}><p>as a Distributor</p></Button2>
            <Button2 light lg to={PUBLISHING} className={styles.actionButton}><p> as a Songwriter or Producer</p></Button2>
            <Button2 light lg to={DEAL_COMPARISON} className={styles.actionButton}><p>by Analyzing Outside Funding Offers</p></Button2>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default LandingV3;
